export enum StatementType {
  Daily = 1,
  Monthly = 2,
}

export const isDailyStatementType = (value?: StatementType) => {
  return StatementType.Daily === value
}

export const isMonthlyStatementType = (value?: StatementType) => {
  return StatementType.Monthly === value
}

export interface StatementFile {
  filename: string
  url: string
}
